(function () {
  var PROGRESS_SELECTOR = '[data-tier-progress]';

  function parseExcludeList(str) {
    if (!str) return [];
    return str
      .split(',')
      .map(function (s) { return (s || '').trim(); })
      .filter(Boolean);
  }

  function typeIsExcluded(productType, excludeList, matchMode) {
    if (!productType || !excludeList || excludeList.length === 0) return false;

    var pt = String(productType).trim().toLowerCase();

    if (matchMode === 'contains') {
      return excludeList.some(function (t) {
        return pt.indexOf(String(t).trim().toLowerCase()) !== -1;
      });
    }

    // exact (default)
    return excludeList.some(function (t) {
      return pt === String(t).trim().toLowerCase();
    });
  }

  // Use ORIGINAL line prices so progress reflects pre-discount spend.
  // This prevents the bar from dropping after a discount applies.
  function computeEligibleTotal(cart, excludeEnabled, excludeList, matchMode) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    var total = 0;

    cart.items.forEach(function (item) {
      var productType = item && item.product_type ? item.product_type : '';

      if (excludeEnabled && typeIsExcluded(productType, excludeList, matchMode)) {
        return;
      }

      var line = 0;
      if (item && typeof item.original_line_price === 'number') {
        line = item.original_line_price;
      } else if (item && typeof item.line_price === 'number') {
        line = item.line_price;
      } else if (item && typeof item.final_line_price === 'number') {
        line = item.final_line_price;
      }

      total += line;
    });

    return total;
  }

  function celebrateTick(el, tierKey) {
    var tick = el.querySelector('.tier-progress__tick[data-tier="' + tierKey + '"]');
    if (!tick) return;

    tick.classList.remove('is-celebrating');
    void tick.offsetWidth; // restart animation reliably
    tick.classList.add('is-celebrating');

    window.setTimeout(function () {
      tick.classList.remove('is-celebrating');
    }, 900);
  }

  function updateTierBars(cart) {
    if (!cart || typeof cart.total_price === 'undefined') return;

    var bars = document.querySelectorAll(PROGRESS_SELECTOR);

    bars.forEach(function (el) {
      var maxThreshold = parseInt(el.getAttribute('data-max-threshold'), 10) || 1;
      var freeThreshold = parseInt(el.getAttribute('data-free-threshold'), 10) || 0;
      var d1Threshold = parseInt(el.getAttribute('data-discount1-threshold'), 10) || 0;
      var d2Threshold = parseInt(el.getAttribute('data-discount2-threshold'), 10) || 0;

      // Exclusion settings (Product Type)
      var excludeEnabled = String(el.getAttribute('data-exclude-types-enabled')) === 'true';
      var excludeList = parseExcludeList(el.getAttribute('data-exclude-product-types'));
      var matchMode = (el.getAttribute('data-exclude-types-match') || 'exact').toLowerCase();

      // Eligible (pre-discount) total excluding configured product types
      var eligibleTotal = computeEligibleTotal(cart, excludeEnabled, excludeList, matchMode);

      var pct = Math.round((eligibleTotal / maxThreshold) * 100);
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;

      var fill = el.querySelector('.tier-progress__fill');
      if (fill) fill.style.width = pct + '%';

      // Tier states
      var reachedFree = freeThreshold > 0 && eligibleTotal >= freeThreshold;
      var reachedD1 = d1Threshold > 0 && eligibleTotal >= d1Threshold;
      var reachedD2 = d2Threshold > 0 && eligibleTotal >= d2Threshold;

      // Celebrate only on crossing
      var prevFree = el.dataset.reachedFree === 'true';
      var prevD1 = el.dataset.reachedD1 === 'true';
      var prevD2 = el.dataset.reachedD2 === 'true';

      if (reachedFree && !prevFree) celebrateTick(el, 'free');
      if (reachedD1 && !prevD1) celebrateTick(el, 'd1');
      if (reachedD2 && !prevD2) celebrateTick(el, 'd2');

      el.dataset.reachedFree = reachedFree ? 'true' : 'false';
      el.dataset.reachedD1 = reachedD1 ? 'true' : 'false';
      el.dataset.reachedD2 = reachedD2 ? 'true' : 'false';

      // Status message uses eligibleTotal so it matches the bar
      var statusEl = el.querySelector('.tier-progress__status');
      if (statusEl) {
        var freeLabel = el.dataset.freeLabel || 'Free shipping';
        var discount1Label = el.dataset.discount1Label || 'Tier 1 discount';
        var discount2Label = el.dataset.discount2Label || 'Tier 2 discount';

        var msg = '';

        if (reachedD2) {
          msg = 'You unlocked ' + discount2Label + '!';
        } else if (reachedD1) {
          msg = 'You unlocked ' + discount1Label + '!';
        } else if (reachedFree) {
          msg = 'You unlocked ' + freeLabel + '!';
        } else if (freeThreshold > 0) {
          var remaining = freeThreshold - eligibleTotal;
          if (remaining > 0) {
            var remainingMajor = (remaining / 100).toFixed(2);
            msg = 'You are $' + remainingMajor + ' away from ' + freeLabel + '.';
          }
        }

        statusEl.textContent = msg;
      }
    });
  }

  function fetchCartAndUpdate() {
    if (fetchCartAndUpdate._timeout) window.clearTimeout(fetchCartAndUpdate._timeout);

    fetchCartAndUpdate._timeout = window.setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) { updateTierBars(cart); })
        .catch(function () {
          // Fail silently
        });
    }, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetchCartAndUpdate();

    // Theme/common cart events
    ['cart:refresh', 'cart:updated', 'ajaxProduct:added', 'cart:changed'].forEach(function (evtName) {
      document.addEventListener(evtName, fetchCartAndUpdate);
    });

    // Quantity changes
    document.body.addEventListener('change', function (event) {
      if (event.target.matches('input[name="updates[]"], .quantity__input, .cart-item__quantity-input')) {
        fetchCartAndUpdate();
      }
    });

    // Add-to-cart forms
    var addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
    addToCartForms.forEach(function (form) {
      form.addEventListener('submit', function () {
        fetchCartAndUpdate();
      });
    });
  });
})();
